<template>
  <div class="parteners">
    <div class="container">
      <div class="part-cont">
        <div class="owl-carousel owl-theme">
          <div class="cont">
            <img src="@/assets/store/img/part1.png">
          </div>
          <div class="cont">
            <img src="@/assets/store/img/part2.png">
          </div>
          <div class="cont">
            <img src="@/assets/store/img/part3.png">
          </div>
          <div class="cont">
            <img src="@/assets/store/img/part4.png">
          </div>
          <div class="cont">
            <img src="@/assets/store/img/part5.png">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import 'owl.carousel';

export default {
  mounted() {
    this.$nextTick(() => {
      this.installOwlCarousel()
    })
  },
  methods: {
    installOwlCarousel: function () {
      window.fn = require('owl.carousel');
      $('.owl-carousel').owlCarousel(
          {
            loop: true,
            mouseDrag: true,
            touchDrag: true,
            pullDrag: false,
            dots: false,
            navSpeed: 700,
            navText: ['', ''],
            responsive: {
              0: {
                items: 3
              },
              400: {
                items: 3
              },
              740: {
                items: 5
              },
              940: {
                items: 5
              }
            },
            nav: true
          }
      )
    }
  }
}
</script>

<style lang="scss">
@import "~@/assets/store/styles.scss";

.parteners {
  background: #1E1E1E;
  padding: 60px 0;
  @media (min-width: $width1) and (max-width: $width2) {
    padding: 8px 0;
  }

  .part-cont {
    margin-top: 20px;
  }
}
</style>
